import { useEffect } from 'react';

import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { type PageTab } from '@backrs_ui/grow-ui/src/redux/tabs/tabKey';
import { clearPageTabs, setPageTabs } from '@backrs_ui/grow-ui/src/redux/tabs/tabs.slice';

/** Replaces the shell's page-content tab with one tab per route while the caller is mounted. */
export const usePageTabs = (tabs: readonly PageTab[]) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPageTabs(tabs));

    return () => {
      dispatch(clearPageTabs());
    };
  }, [tabs, dispatch]);
};
